<template>
  <div
    :key="card.title"
    class="flex flex-col gap-4 w-full lg:flex-1 lg:min-w-[160px] cursor-pointer"
  >
    <div class="rounded-lg overflow-hidden relative">
      <img :src="card.image" :alt="card.title" class="w-full h-full object-scale" />
      <div class="absolute inset-0 flex items-center justify-center">
        <div
          v-if="card.type == 'video'"
          class="w-12 h-12 rounded-full bg-white flex items-center justify-center"
        >
          <svg class="w-5 h-5 ml-0.5" viewBox="0 0 24 24" fill="black">
            <polygon points="6,3 21,12 6,21" />
          </svg>
        </div>
      </div>
    </div>
    <div>
      <h4 class="text-base font-semibold font-inter text-strongest">
        {{ card.title }}
      </h4>
      <p
        v-if="card.subtext"
        class="text-sm text-sm text-strong font-medium font-inter lg:mt-1"
        :class="card.id !== 3 ? 'line-clamp-2' : ''"
      >
        {{ card.subtext }}
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  card: { type: Object, default: () => ({}) },
});
</script>
